import React from "react";
import Nav from "../components/Navbar/Nav";
import Header from "../components/header/Header"

const Home = () => {
  return (
    <>
      <Nav />
      <Header />
    </>
  );
};

export default Home;
